import PageContentLoading from './PageContentLoading';

export default PageContentLoading;